var api = require("!../../../../style-loader@1.3.0-1504fb6c89bf499b00c3/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../css-loader@5.2.7-0e654cc9547db7ee1a8a/node_modules/css-loader/dist/cjs.js!./slick.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};